<template>
    <div class="mt-20 mb-20" id="place-order-page" v-loading="loadingCart">
        <div v-if="calendar.is_billable_edit && cart && !cart.editable">
            Your order is on billable edit. Please go to
            <router-link :to="{ name: Routes.CHECKOUT }">checkout</router-link>
            if you're done updating your calendars.
        </div>
        <el-row :gutter="30" v-else>
            <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="16">
                <template>
                    <el-form>
                        <el-checkbox
                            @change="onChangeRepeatLastOrder"
                            v-if="current_community.has_previous_order"
                            v-model="repeatLastOrder"
                            style="margin-top: 20px"
                        >
                            <span class="repeat-order-title"
                                >Repeat last month's order</span
                            >
                            <div class="repeat-order-description">
                                Click here to add the same items as last month
                            </div>
                        </el-checkbox>
                        <h3>Product Selection</h3>
                        <el-collapse v-model="activeTabs">
                            <el-collapse-item
                                title="Printed Color Copies"
                                name="1"
                            >
                                <div class="flex-row product-cards">
                                    <div
                                        :key="size.id"
                                        class="flex-col-33 flex-col-xl-25"
                                        v-for="size in flatSizes"
                                    >
                                        <product-card
                                            :calendar-format="calendarFormat"
                                            :added-to-cart="
                                                isAddedToCart({
                                                    size,
                                                    color_type:
                                                        ColorTypes.COLORED,
                                                    calendar_id: calendar.id
                                                })
                                            "
                                            :color-type="ColorTypes.COLORED"
                                            :order-item-size="
                                                size.order_item_size[
                                                    ColorTypes.COLORED
                                                ]
                                            "
                                            :size="size"
                                            :custom-title="
                                                form.is_weekly
                                                    ? 'Quantity of calendar/newsletters with the Weekly Calendar'
                                                    : null
                                            "
                                            :loading="
                                                isItemBusy(
                                                    size,
                                                    'adding-to-cart-' +
                                                        ColorTypes.COLORED
                                                )
                                            "
                                            @change-quantity="
                                                (quantity) =>
                                                    onChangeQuantity({
                                                        quantity,
                                                        order_item_size:
                                                            size
                                                                .order_item_size[
                                                                ColorTypes
                                                                    .COLORED
                                                            ],
                                                        size
                                                    })
                                            "
                                            @delete="
                                                onDeleteSize({
                                                    order_item_size:
                                                        size.order_item_size[
                                                            ColorTypes.COLORED
                                                        ]
                                                })
                                            "
                                            @add-to-cart="addToCart"
                                        />
                                    </div>
                                </div>
                            </el-collapse-item>
                            <el-collapse-item
                                name="2"
                                title="Printed Black Ink Copies"
                                v-if="!form.is_weekly && !coloredOnly"
                            >
                                <div class="flex-row product-cards">
                                    <div
                                        :key="size.id"
                                        class="flex-col-33 flex-col-xl-25"
                                        v-for="size in flatSizes"
                                    >
                                        <product-card
                                            :calendar-format="calendarFormat"
                                            :added-to-cart="
                                                isAddedToCart({
                                                    size,
                                                    color_type:
                                                        ColorTypes.BLACK_AND_WHITE,
                                                    calendar_id: calendar.id
                                                })
                                            "
                                            :order-item-size="
                                                size.order_item_size[
                                                    ColorTypes.BLACK_AND_WHITE
                                                ]
                                            "
                                            :size="size"
                                            @change-paper-color="
                                                (color) =>
                                                    onChangePaperColor({
                                                        color,
                                                        order_item_size:
                                                            size
                                                                .order_item_size[
                                                                ColorTypes
                                                                    .BLACK_AND_WHITE
                                                            ],
                                                        size
                                                    })
                                            "
                                            :color-type="
                                                ColorTypes.BLACK_AND_WHITE
                                            "
                                            :loading="
                                                isItemBusy(
                                                    size,
                                                    'adding-to-cart-' +
                                                        ColorTypes.BLACK_AND_WHITE
                                                )
                                            "
                                            @change-quantity="
                                                (quantity) =>
                                                    onChangeQuantity({
                                                        quantity,
                                                        order_item_size:
                                                            size
                                                                .order_item_size[
                                                                ColorTypes
                                                                    .BLACK_AND_WHITE
                                                            ],
                                                        size
                                                    })
                                            "
                                            @delete="
                                                onDeleteSize({
                                                    order_item_size:
                                                        size.order_item_size[
                                                            ColorTypes.COLORED
                                                        ]
                                                })
                                            "
                                            :requires-paper-color="
                                                size.id !== 3
                                            "
                                            @add-to-cart="addToCart"
                                        />
                                    </div>
                                </div>
                            </el-collapse-item>
                            <el-collapse-item
                                title="Printed Color Posters"
                                name="3"
                            >
                                <div
                                    :gutter="10"
                                    class="product-cards flex-row"
                                >
                                    <div
                                        :key="size.id"
                                        class="flex-col-33 flex-col-xl-25"
                                        v-for="size in posterSizes"
                                    >
                                        <product-card
                                            :calendar-format="calendarFormat"
                                            :added-to-cart="
                                                isAddedToCart({
                                                    size,
                                                    color_type:
                                                        ColorTypes.COLORED,
                                                    calendar_id: calendar.id
                                                })
                                            "
                                            :color-type="ColorTypes.COLORED"
                                            :order-item-size="
                                                size.order_item_size[
                                                    ColorTypes.COLORED
                                                ]
                                            "
                                            :size="size"
                                            :loading="
                                                isItemBusy(
                                                    size,
                                                    'adding-to-cart-' +
                                                        ColorTypes.COLORED
                                                )
                                            "
                                            @change-quantity="
                                                (quantity) =>
                                                    onChangeQuantity({
                                                        quantity,
                                                        order_item_size:
                                                            size
                                                                .order_item_size[
                                                                ColorTypes
                                                                    .COLORED
                                                            ],
                                                        size
                                                    })
                                            "
                                            @delete="
                                                onDeleteSize({
                                                    order_item_size:
                                                        size.order_item_size[
                                                            ColorTypes.COLORED
                                                        ]
                                                })
                                            "
                                            @add-to-cart="addToCart"
                                        />
                                    </div>
                                </div>
                            </el-collapse-item>
                            <el-collapse-item
                                name="4"
                                title="Printed Black Ink Posters"
                                v-if="!form.is_weekly && !coloredOnly"
                            >
                                <div
                                    :gutter="10"
                                    class="product-cards flex-row"
                                >
                                    <div
                                        :key="size.id"
                                        class="flex-col-33 flex-col-xl-25"
                                        v-for="size in posterSizes"
                                    >
                                        <product-card
                                            :calendar-format="calendarFormat"
                                            :added-to-cart="
                                                isAddedToCart({
                                                    size,
                                                    color_type:
                                                        ColorTypes.BLACK_AND_WHITE,
                                                    calendar_id: calendar.id
                                                })
                                            "
                                            :color-type="
                                                ColorTypes.BLACK_AND_WHITE
                                            "
                                            :order-item-size="
                                                size.order_item_size[
                                                    ColorTypes.BLACK_AND_WHITE
                                                ]
                                            "
                                            :size="size"
                                            :loading="
                                                isItemBusy(
                                                    size,
                                                    'adding-to-cart-' +
                                                        ColorTypes.BLACK_AND_WHITE
                                                )
                                            "
                                            @change-quantity="
                                                (quantity) =>
                                                    onChangeQuantity({
                                                        quantity,
                                                        order_item_size:
                                                            size
                                                                .order_item_size[
                                                                ColorTypes
                                                                    .BLACK_AND_WHITE
                                                            ],
                                                        size
                                                    })
                                            "
                                            @delete="
                                                onDeleteSize({
                                                    order_item_size:
                                                        size.order_item_size[
                                                            ColorTypes
                                                                .BLACK_AND_WHITE
                                                        ]
                                                })
                                            "
                                            @add-to-cart="addToCart"
                                        />
                                    </div>
                                </div>
                            </el-collapse-item>
                            <el-collapse-item
                                title="Digital Files"
                                name="5"
                                v-if="!form.is_weekly"
                            >
                                <div class="product-cards flex-row">
                                    <div
                                        :key="file.id"
                                        class="flex-col-33 flex-col-xl-25"
                                        v-for="file in computedDigitalFiles"
                                    >
                                        <product-card
                                            :added-to-cart="
                                                isAddedToCart({
                                                    digital_file: file,
                                                    calendar_id: calendar.id
                                                })
                                            "
                                            :digital-file="file"
                                            :loading="
                                                isItemBusy(
                                                    file,
                                                    'adding-to-cart'
                                                )
                                            "
                                            :order-item-digital-file="
                                                file.order_item_digital_file
                                            "
                                            @delete="
                                                onDeleteDigitalFile({
                                                    order_item_digital_file:
                                                        file.order_item_digital_file
                                                })
                                            "
                                            @add-to-cart="addToCart"
                                            :requires-quantity="false"
                                        />
                                    </div>
                                </div>
                            </el-collapse-item>
                            <el-collapse-item
                                title="Custom Birthday Posters"
                                name="6"
                                v-if="!form.is_weekly"
                            >
                                <birthday-posters
                                    :posters="birthday_posters"
                                    :saving="birthdayPostersForm.busy"
                                    :month="calendar.month"
                                    :year="calendar.year"
                                    @save="saveBirthdayPosters()"
                                    style="max-width: 1000px"
                                />
                            </el-collapse-item>
                            <el-collapse-item
                                title="Printed Extras"
                                name="7"
                                v-if="!form.is_weekly"
                            >
                                <div
                                    :gutter="10"
                                    class="product-cards flex-row"
                                >
                                    <div
                                        :key="extra.id"
                                        class="flex-col-33 flex-col-xl-25"
                                        v-for="extra in computedPrintedExtras"
                                    >
                                        <product-card
                                            v-if="extra.is_active"
                                            :loading="
                                                isItemBusy(
                                                    extra,
                                                    'adding-to-cart'
                                                )
                                            "
                                            :added-to-cart="
                                                isAddedToCart({
                                                    printed_extra: extra,
                                                    calendar_id: calendar.id
                                                })
                                            "
                                            :order-item-printed-extra="
                                                extra.order_item_printed_extra
                                            "
                                            :printed-extra="extra"
                                            @add-to-cart="addToCart"
                                            @change-quantity="
                                                (quantity) =>
                                                    onChangePrintedExtraQuantity(
                                                        {
                                                            quantity,
                                                            order_item_printed_extra:
                                                                extra.order_item_printed_extra
                                                        }
                                                    )
                                            "
                                            @delete="
                                                onDeletePrintedExtra({
                                                    order_item_printed_extra:
                                                        extra.order_item_printed_extra
                                                })
                                            "
                                        />
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </el-form>
                </template>
            </el-col>
            <el-col
                :xs="24"
                :sm="24"
                :md="10"
                :lg="10"
                :xl="8"
                v-show="showCart"
            >
                <div class="shopping-cart-container">
                    <cart
                        ref="cart"
                        :show-checkout-button="true"
                        :show-summary="false"
                        :show-product-total="true"
                    />
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import * as BusEvents from "@/constants/bus-events";
import * as CalendarFormats from "@/constants/calendar-formats";
import * as CalendarStatus from "@/constants/calendar-statuses";
import * as ColorTypes from "@/constants/color-types";
import * as Routes from "@/constants/routes";
import * as SizeTypes from "@/constants/size-types";
import Sizes from "@/constants/sizes";
import address from "@/mixins/address";
import cart_updated_listener from "@/mixins/cart-updated-listener";
import cart_mixin from "@/mixins/cart_mixin";
import * as Actions from "@/store/constants/actions";
import * as Getters from "@/store/constants/getters";
import * as Mutations from "@/store/constants/mutations";
import _ from "lodash";
import Vue from "vue";
import { loadStripe } from "@stripe/stripe-js";
import { mapGetters, mapState } from "vuex";
import BirthdayPosters from "./place-order/BirthdayPosters";
import Cart from "./place-order/Cart";
import ProductCard from "./place-order/ProductCard";
//uses https.js imported in window.App

export default {
    mixins: [address, cart_mixin, cart_updated_listener],
    props: {
        form: {
            type: Object,
            required: true
        },
        calendar: {
            type: Object,
            required: true
        },
        order: {
            type: Object,
            default: null
        }
    },
    components: {
        Cart,
        ProductCard,
        BirthdayPosters
    },
    data() {
        return {
            Routes,
            CalendarStatus,
            ColorTypes,
            activeTabs: [],
            orderForm: new Form({
                calendar_id: this.calendar.id,
                community_location_id: null,
                sizes: [],
                card_token: null,
                use_existing: false
            }),
            cartForm: new Form({
                orders: []
            }),
            selected_order_sizes: [],
            selected_sizes: [],
            birthday_posters: [],
            complete: false,
            dialogVisible: false,
            showCart: true,
            repeatLastOrder: false,
            repeatLastOrderForm: new Form({
                calendar_id: this.calendar.id
            }),
            loadingCart: false,
            birthdayPostersForm: new Form({
                calendar_id: this.calendar.id,
                birthday_posters: []
            }),
            stripeOptions: {
                style: {
                    base: {
                        color: "#32325d",
                        lineHeight: "18px",
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: "antialiased",
                        fontSize: "16px",
                        "::placeholder": {
                            color: "#aab7c4"
                        }
                    },
                    invalid: {
                        color: "#fa755a",
                        iconColor: "#fa755a"
                    }
                }
            }
        };
    },
    mounted() {
        this.initSizes();
        this.initOrderForm();
        if (this.hasExistingCard) {
            this.orderForm.use_existing = true;
        }

        this.loadingCart = true;
        this.$store
            .dispatch(Actions.FETCH_CART)
            .then((response) => {
                this.cartForm.orders = _.cloneDeep(response.data.orders);
                this.birthday_posters = _.get(
                    this.orderItem,
                    "birthday_posters",
                    []
                );
                this.initRepeatOrderOptions();
            })
            .catch((e) => {
                console.log("mounted", e);
            })
            .finally(() => (this.loadingCart = false));

        Vue.nextTick(() => {
            window.Bus.$emit(BusEvents.UPDATE_SCROLLER);
        });
        this.orderForm.community_location_id =
            this.calendar.community_location_id;
    },
    computed: {
        ...mapState(["sizes", "cart", "current_community"]),
        ...mapState({
            printed_extras: (state) => state.printed_extras.data
        }),
        digital_files() {
            return this.$store.getters[Getters.CALENDAR_DIGITAL_FILES];
        },
        ...mapGetters([
            Getters.WEEKLY_CALENDAR_AVAILABLE_SIZES,
            Getters.WEEKLY_CALENDAR_AVAILABLE_FLAT_SIZES,
            Getters.WEEKLY_CALENDAR_AVAILABLE_POSTER_SIZES
        ]),
        orderItem() {
            return _.find(this.cartForm.orders, {
                calendar_id: this.calendar.id
            });
        },
        predefinedColors() {
            return this.$store.state.config.settings.paper_colors;
        },
        stripeKey() {
            return this.$store.state.config.services.stripe.key;
        },
        quantityAmount() {
            return _.sumBy(this.selected_order_sizes, (item) => {
                return item.quantity * item.size.price;
            });
        },
        totalAmount() {
            return (
                _.sumBy(this.pricing, (price) => price.amount) +
                this.quantityAmount
            );
        },
        hasExistingCard() {
            return this.$store.state.user.has_card;
        },
        locations() {
            return this.$store.state.current_community.locations.data;
        },
        pricing() {
            let pricing = [
                {
                    name: "Location Keys/Custom Text",
                    amount: this.calendar.pricing.location_keys
                },
                {
                    name: "Logo",
                    amount: this.calendar.pricing.logo
                },
                {
                    name: "Custom Title",
                    amount: this.calendar.pricing.title
                }
            ];
            return pricing.filter((item) => item.amount > 0);
        },
        flatSizes() {
            let sizes = _.filter(this.sizes.data, { type: SizeTypes.FLAT });
            if (this.form.is_weekly) {
                sizes = this[Getters.WEEKLY_CALENDAR_AVAILABLE_FLAT_SIZES];
            }
            if (this.limitFlats && !this.form.is_weekly) {
                sizes = sizes.filter((size) => size.id === Sizes.size11x17);
            }
            return sizes.map((size) => {
                let order_item_size = {};
                _.forEach(ColorTypes, (type) => {
                    order_item_size[type] = this.orderItem
                        ? this.orderItem.sizes.find((item_size) => {
                              return (
                                  item_size.id === size.id &&
                                  item_size.color_type === type
                              );
                          })
                        : null;
                });
                return {
                    ...size,
                    order_item_size
                };
            });
        },
        posterSizes() {
            let sizes = _.filter(this.sizes.data, { type: SizeTypes.POSTER });
            if (this.form.is_weekly) {
                sizes = this[Getters.WEEKLY_CALENDAR_AVAILABLE_POSTER_SIZES];
            }
            if (this.limitPosters && !this.form.is_weekly) {
                sizes = _.reject(sizes, (size) =>
                    [Sizes.size22x34, Sizes.size36x60].includes(size.id)
                );
            }
            return sizes.map((size) => {
                let order_item_size = {};
                _.forEach(ColorTypes, (type) => {
                    order_item_size[type] = this.orderItem
                        ? this.orderItem.sizes.find((item_size) => {
                              return (
                                  item_size.id === size.id &&
                                  item_size.color_type === type
                              );
                          })
                        : null;
                });
                return {
                    ...size,
                    order_item_size
                };
            });
        },
        calendarFormat() {
            return this.form.is_weekly
                ? CalendarFormats.WEEKLY
                : CalendarFormats.MONTHLY;
        },
        computedDigitalFiles() {
            return this.digital_files.map((file) => {
                return {
                    ...file,
                    order_item_digital_file: this.orderItem
                        ? this.orderItem.digital_files.find(
                              (item) => item.id === file.id
                          )
                        : null
                };
            });
        },
        computedPrintedExtras() {
            let printed_extras_sorted = _.orderBy(
                this.printed_extras,
                ["type", "display_order"],
                "asc"
            );
            //console.log('computedPrintedExtras (calendar)', {printed_extras_sorted});
            return printed_extras_sorted.map((extra) => {
                return {
                    ...extra,
                    order_item_printed_extra: this.orderItem
                        ? this.orderItem.printed_extras.find(
                              (item) => item.id === extra.id
                          )
                        : null
                };
            });
        }
    },
    watch: {
        "orderForm.use_existing"(value) {
            Vue.nextTick(() => {
                window.Bus.$emit(BusEvents.UPDATE_SCROLLER);
            });
        }
    },
    methods: {
        onCartUpdated(cart) {
            this.cartForm.orders = _.cloneDeep(cart.orders);
            this.birthday_posters = _.get(
                this.orderItem,
                "birthday_posters",
                []
            );
        },
        initRepeatOrderOptions() {
            let order_item = _.find(this.cartForm.orders, {
                calendar_id: this.calendar.id
            });
            if (order_item) {
                this.repeatLastOrder = _.get(
                    order_item,
                    "repeat_last_month_order",
                    false
                );
            }
        },
        initSizes() {
            _.forEach(this.sizes.data, (val) => {
                this.selected_order_sizes.push({
                    size_id: val.id,
                    size: val,
                    paper_color: val.paper_color ? "#000" : null,
                    quantity: null
                });
            });
        },
        initOrderForm() {
            if (this.order) {
                let order_item = this.order.items.data.find((item) => {
                    return item.id === parseInt(this.$route.query.item_id);
                });
                _.forEach(order_item.sizes.data, (val) => {
                    let selected_order_size = _.find(
                        this.selected_order_sizes,
                        { size_id: val.size_id }
                    );
                    if (selected_order_size) {
                        this.selected_sizes.push(val.size_id);
                        selected_order_size.paper_color = val.paper_color;
                        selected_order_size.quantity = val.quantity;
                    }
                });
            }
        },
        onColorActiveChange(color, size) {
            size.paper_color = window.Utils.rgbToHex(color);
        },
        hasNotSelectedSize(size) {
            return _.indexOf(this.selected_sizes, size.size_id) === -1;
        },
        onChangeCheckBoxValue(val, size) {
            if (val) {
                size.quantity = 1;
            } else {
                size.quantity = null;
            }
        },
        checkout() {
            this.dialogVisible = false;
            this.$router.push({
                name: "Checkout"
            });
        },
        addToCart(payload) {
            let form = new Form({
                calendar_id: this.calendar.id
            });
            let action;
            let busy_item;
            if (payload.size) {
                busy_item = payload.size;
                action = "adding-to-cart-" + payload.color_type;
                form["item_size"] = {
                    size_id: payload.size.id,
                    ..._.pick(payload, [
                        "quantity",
                        "color_type",
                        "paper_color",
                        "best_judgement"
                    ])
                };
            } else if (payload.digital_file) {
                busy_item = payload.digital_file;
                action = "adding-to-cart";
                form["digital_file"] = {
                    id: payload.digital_file.id
                };
            } else if (payload.printed_extra) {
                busy_item = payload.printed_extra;
                action = "adding-to-cart";
                form["printed_extra"] = {
                    id: payload.printed_extra.id,
                    quantity: payload.quantity
                };
            } else {
                return;
            }
            this.addBusyItem(busy_item, action);
            window.App.post(`/web-api/cart`, form)
                .then(() => {
                    payload.component.reset();
                    this.$refs.cart.refresh();
                    this.$notify.success({
                        message: "Item has been added to cart."
                    });
                })
                .catch((e) => {
                    console.log("addToCart", e);
                })
                .finally(() => {
                    this.removeBusyItem(busy_item, action);
                });
        },
        saveBirthdayPosters() {
            this.birthdayPostersForm.birthday_posters = _.values(
                _.filter(this.birthday_posters, (item) => {
                    return (
                        item.name &&
                        !_.isEmpty(item.name.trim()) &&
                        !_.isEmpty(item.birth_date)
                    );
                })
            );
            window.App.post(
                `/web-api/cart/birthday-posters`,
                this.birthdayPostersForm
            ).then((response) => {
                this.$store.commit(Mutations.SET_CART, response.data);
                this.$notify.success({
                    message: "Cart has been updated."
                });
            });
        },
        hideCart() {
            this.showCart = false;
        },
        onChangeRepeatLastOrder() {
            if (this.repeatLastOrder) {
                window.App.post(
                    `/web-api/cart/repeat`,
                    this.repeatLastOrderForm
                )
                    .then((response) => {
                        this.$store.commit(Mutations.SET_CART, response.data);
                        this.cartForm.orders = _.cloneDeep(
                            response.data.orders
                        );
                    })
                    .catch((e) => {
                        console.log("onChangeRepeatLastOrder", e);
                    });
            } else {
                this.cartForm.orders = _.reject(this.cartForm.orders, {
                    calendar_id: this.calendar.id
                });
                this.submitCart();
            }
        },
        submitCart() {
            return window.App.put(`/web-api/cart`, this.cartForm).then(
                (response) => {
                    this.$store.commit(Mutations.SET_CART, response.data);
                    return response;
                }
            );
        },
        onChangeQuantity({ order_item_size = null, quantity, size = null }) {
            //console.log('onChangeQuantity', {order_item_size, quantity, size});
            if (order_item_size) {
                order_item_size.quantity = quantity;
                this.submitCart()
                    .then(() => {
                        this.$notify.success({
                            message: "Quantity has been updated."
                        });
                    })
                    .catch((e) => {
                        console.log("onChangeQuantity", e);
                    });
            }
        },
        onChangePrintedExtraQuantity({
            order_item_printed_extra = null,
            quantity
        }) {
            //console.log('onChangePrintedExtraQuantity (calendar)', {order_item_printed_extra, quantity});
            if (order_item_printed_extra) {
                order_item_printed_extra.quantity = quantity;
                this.submitCart()
                    .then(() => {
                        this.$notify.success({
                            message: "Quantity has been updated."
                        });
                    })
                    .catch((e) => {
                        console.log("onChangePrintedExtraQuantity", e);
                    });
            }
        },
        onChangePaperColor({ order_item_size = null, color, size = null }) {
            //console.log('onChangePaperColor', {order_item_size, color, size});
            if (order_item_size) {
                order_item_size.paper_color = color;
                this.submitCart()
                    .then(() => {
                        this.$notify.success({
                            message: "Paper color has been updated."
                        });
                    })
                    .catch((e) => {
                        console.log("onChangePaperColor", e);
                    });
            }
        },
        successItemRemoved() {
            this.$notify.success({
                message: "Item has been removed from cart."
            });
        },
        confirmRemove() {
            return this.$confirm(
                "Are you sure you want to remove item from shopping cart?",
                "Warning",
                {
                    confirmButtonText: "Remove",
                    confirmButtonClass: "el-button--danger",
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            ).catch(() => {
                //user cancelled
            });
        },
        onDeleteSize({ order_item_size }) {
            //console.log('onDeleteSize', {order_item_size});
            this.confirmRemove().then(() => {
                Utils.arrayDelete(this.orderItem.sizes, order_item_size);
                this.submitCart().then(() => {
                    this.successItemRemoved();
                });
            });
        },
        onDeleteDigitalFile({ order_item_digital_file }) {
            this.confirmRemove().then(() => {
                Utils.arrayDelete(
                    this.orderItem.digital_files,
                    order_item_digital_file
                );
                this.submitCart()
                    .then(() => {
                        this.successItemRemoved();
                    })
                    .catch((e) => {
                        console.log("onDeleteDigitalFile", e);
                    });
            });
        },
        onDeletePrintedExtra({ order_item_printed_extra }) {
            this.confirmRemove().then(() => {
                Utils.arrayDelete(
                    this.orderItem.printed_extras,
                    order_item_printed_extra
                );
                this.submitCart()
                    .then(() => {
                        this.successItemRemoved();
                    })
                    .catch((e) => {
                        console.log("onDeletePrintedExtra", e);
                    });
            });
        },
        submit() {
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    return;
                }
                if (this.totalAmount <= 0) {
                    this.$alert(
                        "Please select calendar sizes to order.",
                        "Oops!",
                        {
                            confirmButtonText: "OK",
                            type: "warning",
                            center: true
                        }
                    );
                    return;
                }

                if (this.order) {
                    this.orderForm.sizes = _.filter(
                        this.selected_order_sizes,
                        (size) => {
                            return (
                                _.indexOf(this.selected_sizes, size.size_id) !==
                                -1
                            );
                        }
                    );
                    this.$confirm(
                        "Confirm save changes to quantities?",
                        "Confirmation",
                        {
                            confirmButtonText: "Save Changes",
                            cancelButtonText: "Cancel",
                            type: "info"
                        }
                    )
                        .then(() => {
                            window.App.put(
                                `/web-api/order/${this.order.id}`,
                                this.orderForm
                            )
                                .then(() => {
                                    this.$notify.success({
                                        message:
                                            "Order details has been updated."
                                    });
                                })
                                .catch((e) => {
                                    console.log("submit", e);
                                });
                        })
                        .catch(() => {
                            //user cancelled
                        });
                } else {
                    this.$confirm(
                        `Confirm add order to cart?`,
                        "Confirmation",
                        {
                            confirmButtonText: "Add to Cart",
                            cancelButtonText: "Cancel",
                            type: "info"
                        }
                    )
                        .then(() => {
                            let new_item;
                            this.cartForm.orders.push(
                                (new_item = {
                                    calendar_id: this.orderForm.calendar_id,
                                    community_location_id:
                                        this.orderForm.community_location_id,
                                    sizes: this.selected_order_sizes
                                        .filter((item) => {
                                            return item.quantity > 0;
                                        })
                                        .map((item) => {
                                            return {
                                                id: item.size.id,
                                                paper_color: item.paper_color,
                                                quantity: item.quantity
                                            };
                                        })
                                })
                            );
                            this.submitCart()
                                .then(() => {
                                    this.$notify.success({
                                        message:
                                            "Calendar successfully added to cart."
                                    });
                                    this.$router.push({
                                        name: "Cart"
                                    });
                                })
                                .catch((e) => {
                                    console.log("submit:", e);
                                    window.Utils.arrayDelete(
                                        this.cartForm.orders,
                                        new_item
                                    );
                                });
                        })
                        .catch(() => {
                            //user cancelled
                        });
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
@use "../../../../../assets/scss/_variables" as vars;

.repeat-order-title {
    font-size: 20px;
    font-weight: bold;
    color: vars.$text-color-warning !important;
}

.repeat-order-description {
    margin-top: 5px;
    color: vars.$text-color-lighter;
    font-style: italic;
}


#place-order-page {
    .el-input {
        width: 100%;
        max-width: 200px;
    }

    .product-cards {
        display: flex;
        flex-wrap: wrap;
        margin: -10px;

        .flex-col-33,
        .flex-col-xl-25 {
            padding: 10px;
            width: 100%;

            @media (min-width: 576px) {
                width: 50%;
            }

            @media (min-width: 768px) {
                width: 33.333%;
            }

            @media (min-width: 1200px) {
                width: 25%;
            }
        }
    }

    .shopping-cart-container {
        margin: 20px auto;
        position: relative;

        @media (max-width: 767px) {
            margin-top: 30px;
            padding: 15px;
            border-top: 1px solid #ebeef5;
        }
    }
}

.el-checkbox {
    margin-bottom: 12px;

    .el-checkbox__input {
        margin-top: 2px;
    }

    .el-checkbox__label {
        display: inline-block;
        line-height: 1.2;
        width: calc(100% - 30px); // Account for checkbox width

        span {
            display: block;
            margin-bottom: 4px;
            word-break: break-word;
        }

        .description {
            font-size: 16px;
            color: #909399;
            white-space: normal;
        }
    }
}

// Add responsive collapse panel styles
// .el-collapse {
//     @media (max-width: 576px) {
//         .el-collapse-item__header {
//             font-size: 14px;
//             padding: 0 15px;
//         }

//         .el-collapse-item__content {
//             padding: 15px;
//         }
//     }
// }

/* Improved collapse item styling */
:deep(.el-collapse-item) {
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  
  .el-collapse-item__header {
    background-color: #f5f7fa;
    font-weight: 600;
    font-size: 18px;
    color: vars.$corwin-blue-green;
    height: 55px;
    line-height: 55px;
    padding: 0 20px;
    border-left: 4px solid vars.$corwin-blue-green;
    display: flex;
    align-items: center;
    
    &:hover {
      background-color: #eef1f6;
    }
    
    &.is-active {
      background-color: vars.$corwin-blue-green;
      color: white;
      border-bottom-color: transparent;
    }
    
    .el-collapse-item__arrow {
      margin-right: 15px;
      margin-left: auto;
      font-size: 16px;
      color: inherit;
    }
  }
  
  .el-collapse-item__content {
    padding: 20px;
    background-color: white;
  }
}
</style>
